import { render, staticRenderFns } from "./Beneficio.vue?vue&type=template&id=0a9e86fc&scoped=true&"
import script from "./Beneficio.vue?vue&type=script&lang=ts&"
export * from "./Beneficio.vue?vue&type=script&lang=ts&"
import style0 from "./Beneficio.vue?vue&type=style&index=0&id=0a9e86fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e86fc",
  null
  
)

export default component.exports